import { render, staticRenderFns } from "./shopMallCircle.vue?vue&type=template&id=a1e5b352&scoped=true&"
import script from "./shopMallCircle.vue?vue&type=script&lang=js&"
export * from "./shopMallCircle.vue?vue&type=script&lang=js&"
import style0 from "./shopMallCircle.vue?vue&type=style&index=0&id=a1e5b352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e5b352",
  null
  
)

export default component.exports